/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UpdateResellerRequest { 
    name?: string;
    websiteUrl?: string;
    logoUrl?: string;
    color?: string;
    email?: string;
    address?: string;
    phone?: string;
    yearFounded?: string;
    other?: string;
}